import styled from 'styled-components';

const StyledDayIndicator = styled.div<{ $sticky?: boolean }>`
  box-shadow: 0px 0px 20px 0px rgba(42, 42, 43, 0.25);
  background-color: ${(props) => props.theme.color.primaryLight};
  z-index: 1;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  border-radius: ${(props) => props.theme.radius.md};
  ${(props) =>
    props.$sticky &&
    `
     position: sticky;
      top: 0.5rem;
   `}
`;
const StyledDayTagMenu = styled.div<{ $isActive: boolean }>`
  background-color: ${(props) => (props.$isActive ? props.theme.color.primary : '')};
  color: ${(props) => (props.$isActive ? props.theme.color.white : props.theme.color.bodyTextColor)};
  padding: 0.75rem 1.5rem;
  border-radius: ${(props) => props.theme.radius.md};
  transition:
    background-color 0.3s ease-in-out,
    color 0.3s ease-in-out;

  &:hover {
    background-color: ${(props) => props.theme.color.primaryHover};
    cursor: pointer;
    p {
      color: ${(props) => props.theme.color.primaryForegroundHover};
    }
  }
`;
export { StyledDayTagMenu };
export { StyledDayIndicator };
